import React from "react";
import type { KgSigmaSquareIconProps } from "./KgSigmaSquareIcon.types";

/** Formula accordion icon for metric inspector (Figma formula section, 16px). */
export const KgSigmaSquareIcon: React.FC<KgSigmaSquareIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M12 4.66797V2.66797H4L8 8.0013L4 13.3346H12V11.3346"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgSigmaSquareIcon;
